import type { FlagConfiguration } from '@atlassian/jira-flags';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import {
	REORDER_ITEM_FAIL_400_FLAG,
	REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM,
	REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA,
	REORDER_ITEM_FAIL_404_FLAG,
	REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM,
	REORDER_ITEM_FAIL_409_FLAG,
	REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM,
} from './constants.tsx';

export const getFlagDetails = (statusCode: number | null): FlagConfiguration | null => {
	switch (statusCode) {
		case 400: {
			if (fg('jira-issue-terminology-refresh-m3')) {
				if (expVal('project-terminology-refresh', 'isEnabled', false)) {
					return REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM_GALAXIA;
				}
				return REORDER_ITEM_FAIL_400_FLAG_WITH_ISSUE_TERM;
			}
			return REORDER_ITEM_FAIL_400_FLAG;
		}
		case 404:
			return fg('jira-issue-terminology-refresh-m3')
				? REORDER_ITEM_FAIL_404_FLAG_WITH_ISSUE_TERM
				: REORDER_ITEM_FAIL_404_FLAG;
		case 409:
			return fg('jira-issue-terminology-refresh-m3')
				? REORDER_ITEM_FAIL_409_FLAG_WITH_ISSUE_TERM
				: REORDER_ITEM_FAIL_409_FLAG;
		default: {
			return null;
		}
	}
};
